<div class="row" style="padding: 5px">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 0px"
							(click)="onRefresh()"
						>
							Refresh
						</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onEditClassAttendance()"
						>
							Edit Class Attendance
						</button>
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onPrintClassAttendance()"
						>
							Print Class Attendance
						</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstClassAttendance"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedClassAttendance"
						dataKey="ClassAttendanceStudentID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--Section-->
								<th>
									<p-columnFilter id="Section" field="Section" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterSection
												[ngModel]="value"
												[options]="lstSection"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--EntryDateDesc-->
								<th>
									<!-- <p-columnFilter type="text" field="EntryDateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--ClassAttendanceStatusDesc-->
								<th>
									<p-columnFilter field="ClassAttendanceStatusDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterClassAttendanceStatusDesc
												[ngModel]="value"
												[options]="lstClassAttendanceStatusDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ClassAttendanceEntryTypeDesc-->
								<th>
									<p-columnFilter field="ClassAttendanceEntryTypeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterClassAttendanceEntryTypeDesc
												[ngModel]="value"
												[options]="lstClassAttendanceEntryTypeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--Excuse-->
								<th>
									<p-columnFilter field="Excuse" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterExcuse
												[ngModel]="value"
												[options]="lstExcuse"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="Section">Section<p-sortIcon field="Section"></p-sortIcon></th>
								<th pSortableColumn="EntryDT">Date/Time<p-sortIcon field="EntryDT"></p-sortIcon></th>
								<th pSortableColumn="ClassAttendanceStatusDesc">Status<p-sortIcon field="ClassAttendanceStatusDesc"></p-sortIcon></th>
								<th pSortableColumn="ClassAttendanceEntryTypeDesc">
									Entry Method<p-sortIcon field="ClassAttendanceEntryTypeDesc"></p-sortIcon>
								</th>
								<th pSortableColumn="Excuse">Excuse<p-sortIcon field="Excuse"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-ClassAttendance>
							<tr [pSelectableRow]="ClassAttendance" (dblclick)="onRowDblClick(ClassAttendance)">
								<td *ngFor="let col of cols" style="font-weight: bold">
									{{ ClassAttendance[col.field] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>

				<div class="TopMargin">
					<div name="isProcessing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
				</div>
			</div>
		</div>
	</div>
</div>
